import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { ModuleName } from '../enums/ModuleName';
import engagementText from '../../../assets/Translations/Engagement.json';
import happinessText from '../../../assets/Translations/Happiness.json';
import psychometricText from '../../../assets/Translations/Psychometric.json';
import surveysText from '../../../assets/Translations/Surveys.json';
import exitText from '../../../assets/Translations/Exit.json';
import commonText from '../../../assets/Translations/Common.json';
import assessmentText from '../../../assets/Translations/Assessment.json';
import assessment180Text from '../../../assets/Translations/Assessment180.json';
import sharedText from '../../../assets/Translations/Shared.json';
import circleText from '../../../assets/Translations/Circle.json';
import onboardingText from '../../../assets/Translations/Onboarding.json';
import wellBeingText from '../../../assets/Translations/Wellbeing.json';
import surveyXText from '../../../assets/Translations/Survey-X.json';
import tooltipsText from '../../../assets/Translations/Tooltips.json';
import defaultText from '../../../assets/Translations/Default.json';
import { TRANSLATION_TOKEN } from '@ex/module/core/domain/translation-token';
import { TranslationCacheService } from '@ex/module/core/services/translation-cache.service';
import cultureText from '../../../assets/Translations/Culture.json';
import aiReadinessText from '../../../assets/Translations/AiReadiness.json';
import announcementsText from '../../../assets/Translations/Announcements.json';


@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {
  isDev: boolean = false;

  translationToken = inject(TRANSLATION_TOKEN);
  private translationCache = inject(TranslationCacheService);

  constructor() {

  }
  transform(value: string, language: string, module: string, variables: string[] = []): any {
    try {
      var lngO = null
      if (!this.translationToken.useJsonFiles) {
        // Use in-memory cache — O(1) lookup, no JSON.parse, no linear .find()
        switch (module) {
          case ModuleName.Onboarding:
            // Onboarding merges with Surveys
            lngO = this.translationCache.lookupMultiple(
              [ModuleName.Onboarding, ModuleName.Surveys], value
            );
            break;
          case ModuleName.Wellbeing:
            // Wellbeing merges with Surveys
            lngO = this.translationCache.lookupMultiple(
              [ModuleName.Wellbeing, ModuleName.Surveys], value
            );
            break;
          case ModuleName.SurveyX:
            // SurveyX merges with Surveys
            lngO = this.translationCache.lookupMultiple(
              [ModuleName.SurveyX, ModuleName.Surveys], value
            );
            break;
          case ModuleName.Culture:
            // Culture merges with Surveys
            lngO = this.translationCache.lookupMultiple(
              [ModuleName.Culture, ModuleName.Surveys], value
            );
            break;
          case ModuleName.AiReadiness:
            // AiReadiness merges with Surveys
            lngO = this.translationCache.lookupMultiple(
              [ModuleName.AiReadiness, ModuleName.Surveys], value
            );
            break;
          case ModuleName.Announcements:
            lngO = this.translationCache.lookup(ModuleName.Announcements, value);
            break;
          default:
            // All other modules: direct single lookup
            lngO = this.translationCache.lookup(module || 'Default', value);
        }
      } else {
        switch (module) {
          case ModuleName.Engagement:
            lngO = engagementText?.find(i => i.key == value)
            break;
          case ModuleName.Happiness:
            lngO = happinessText?.find(i => i.key == value)
            break;
          case ModuleName.Exit:
            lngO = exitText?.find(i => i.key == value)
            break;
          case ModuleName.Assessment:
            lngO = assessmentText?.find(i => i.key == value)
            break;
          case ModuleName.Assessment180:
            lngO = assessment180Text?.find(i => i.key == value)
            break;
          case ModuleName.Circle:
            lngO = circleText?.find(i => i.key == value)
            break;
          case ModuleName.Psychometric:
            lngO = psychometricText?.find(i => i.key == value)
            break;
          case ModuleName.Common:
            lngO = commonText.find(i => i.key == value)
            break;
          case ModuleName.Shared:
            lngO = sharedText?.find(i => i.key == value)
            break;
          case ModuleName.Surveys:
            lngO = surveysText?.find(i => i.key == value)
            break;
          case ModuleName.Wellbeing:

            let surveysWB = [...wellBeingText, ...surveysText]

            lngO = surveysWB?.find(i => i.key == value)

            break;
          case ModuleName.Onboarding:
            let surveysOnB = [...onboardingText, ...surveysText]
            lngO = surveysOnB?.find(i => i.key == value)
            break;
          case ModuleName.SurveyX:
            let SurveyX = [...surveyXText, ...surveysText]
            lngO = SurveyX?.find(i => i.key == value)
            break;
          case ModuleName.Tooltips:
            lngO = tooltipsText?.find(i => i.key == value)
            break;
          case ModuleName.Announcements:
            lngO = announcementsText?.find(i => i.key == value)
            break;
          case ModuleName.Culture:
            let surveysCulture = [...cultureText, ...surveysText]
            lngO = surveysCulture?.find(i => i.key == value)
            break;
          case ModuleName.AiReadiness:
            let surveysAiReadiness = [...aiReadinessText, ...surveysText]
            lngO = surveysAiReadiness?.find(i => i.key == value)
            break;
          default:
            lngO = defaultText?.find(i => i.key == value)
        }
      }

      var text = this.getUILanguage(lngO, language)
      var textEN = this.getUILanguage(lngO, "EN")
      const translatedText = text?.length ? text : textEN;

      if (translatedText?.length)
        return variables?.length ? this.replacePlaceholders(translatedText, variables) : translatedText

      return value
    } catch (err: any) {
      return "";
    }
  }
  getUILanguage(lngO, language: string) {
    if (language == "EN") {
      if (lngO) {
        return lngO.text;
      }
    } else {
      if (lngO) {
        let translation = lngO.translations.find(cT => (cT.language == language));
        if (translation) {
          return translation.text;
        }
      }
    }
    return ""
  }

  private replacePlaceholders(input: string, reps: string[]): string {
    let i = 0;
    return input.replace(/{{.*?}}/g, () => reps[i++] ?? '');
  }
}
